import React from 'react'
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked'
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked'

import cx from 'classnames'

import Label from './label'

import './ui.scss'

const Radio = ({
  className,
  label,
  name,
  checked,
  disabled,
  ...props
}) => {
  const classes = cx(className, 'm-radio', {
    'm-radio--checked': checked,
    'm-radio--disabled': disabled,
  })

  return (
    <Label>
      <span className={classes}>
        <input
          className="m-radio__input"
          type="radio"
          name={name}
          checked={checked}
          disabled={disabled}
          {...props}
        />

        <span className="m-radio__control">
          { checked
            ? <RadioButtonCheckedIcon />
            : <RadioButtonUncheckedIcon /> }
        </span>
      </span>

      { label &&
        <span className="m-radio__label">{label}</span> }
    </Label>
  )
}

export default Radio
